import { p as public_env } from "../../../chunks/shared-server.js";
const load = async ({ params, url }) => {
  let page = url.searchParams.get("page");
  if (!page) page = 0;
  const count = 20;
  const INDEXER_BASE_URL = public_env.PUBLIC_INDEXER_BASE_URL;
  const apiUrl = `${INDEXER_BASE_URL}/txs?page=${page}&count=${count}`;
  console.log(apiUrl);
  const res = await fetch(apiUrl);
  const data = await res.json();
  const { total, total_pages, transaction_summaries } = data;
  console.log(transaction_summaries);
  if (res.ok) {
    return {
      txs: transaction_summaries,
      total,
      total_pages,
      page,
      count
    };
  }
  return {
    status: 404,
    body: { error: "Can not fetch recepie." }
  };
};
export {
  load
};
